import { useEffect, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Loader2, Star } from "lucide-react";
import { toast } from "sonner";
import { fetchReviews, saveReviews } from "@/lib/noleggio";

export default function AdminReviews() {
  const qc = useQueryClient();
  const q = useQuery({ queryKey: ["reviews"], queryFn: fetchReviews });
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (q.data && !f) setF({ rating: String(q.data.rating).replace(".", ","), count: String(q.data.count), url: q.data.url });
  }, [q.data, f]);
  if (!f) return null;

  const save = async () => {
    setBusy(true);
    try {
      await saveReviews({ rating: parseFloat(f.rating.replace(",", ".")), count: parseInt(f.count, 10), url: f.url.trim() });
      qc.invalidateQueries({ queryKey: ["reviews"] });
      toast.success("Recensioni aggiornate");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };
  const field = (k, label, extra) => (
    <label className="flex flex-col gap-1"><span className="mn-label">{label}</span>
      <input data-testid={`admin-reviews-${k}`} className="mn-input" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} {...extra} /></label>
  );
  return (
    <div data-testid="admin-reviews-card" className="mn-card p-4 mt-3 flex flex-col gap-3">
      <p className="font-bold text-sm flex items-center gap-2"><Star size={18} color="#F4B400" fill="#F4B400" /> Stelle Google mostrate nel catalogo</p>
      <div className="grid grid-cols-2 md:grid-cols-[110px_130px_1fr_auto] gap-3 items-end">
        {field("rating", "Voto", { inputMode: "decimal" })}
        {field("count", "N. recensioni", { inputMode: "numeric" })}
        <div className="col-span-2 md:col-span-1">{field("url", "Link pagina Google")}</div>
        <button data-testid="admin-reviews-save" className="mn-btn col-span-2 md:col-span-1 !min-h-[50px]" disabled={busy} onClick={save}>
          {busy && <Loader2 size={16} className="animate-spin" />} Salva
        </button>
      </div>
    </div>
  );
}
